import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=a615b532&scoped=true"
import script from "./project-list.vue?vue&type=script&lang=js"
export * from "./project-list.vue?vue&type=script&lang=js"
import style0 from "./project-list.vue?vue&type=style&index=0&id=a615b532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a615b532",
  null
  
)

export default component.exports